<template>
    <nav id="sidebar" class="sidebar bg-white">
        <div class="simplebar-wrapper m-0">
            <div class="simplebar-mask">
                <div class="simplebar-offset">
                    <div class="simplebar-content-wrapper">
                        <div class="simplebar-content p-0">
                            <div class="simplebar-title bg-azul">
                                <div class="content-header bg-white-10">
                                    FacturaSoft
                                    <i class="fa fa-times-circle tacha"
                                    @click="close"></i>
                                </div>
                            </div>

                            <List />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div></div>
    </nav>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex'
    import List from "./List/List";

    export default {
        name: "Nav",
        components: {List},

        model: {
            prop: 'menu',
            event: 'open'
        },
        props: {
            menu: Boolean
        },

        methods: {

            ...mapMutations([
                'SET_MENU',
            ]),

            close: function () {
                this.SET_MENU(!this.menu);
                this.$emit('open', !this.menu);
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../style/base";

    .sidebar {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        z-index: 1032;
        width: 100%;
        height: 100%;
        background-color: #fff;
        transform: translateX(-100%) translateY(0) translateZ(0);
        will-change: transform;
        overflow-y: visible;
        transition: transform .6s cubic-bezier(.215,.61,.355,1),-webkit-transform .6s cubic-bezier(.215,.61,.355,1);
        box-shadow: -11px 0px 12px 2px #444;

        & .simplebar-wrapper {
            overflow: hidden;
            width: inherit;
            height: inherit;
            max-width: inherit;
            max-height: inherit;

            & .simplebar-mask {
                direction: inherit;
                position: absolute;
                overflow: hidden;
                padding: 0;
                margin: 0;
                left: 0;
                top: 0;
                bottom: 0;
                right: 0;
                width: auto !important;
                height: auto !important;
                z-index: 0;

                & .simplebar-offset {
                    direction: inherit !important;
                    box-sizing: inherit !important;
                    resize: none !important;
                    position: absolute;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    right: 0;
                    padding: 0;
                    margin: 0;

                    & .simplebar-content-wrapper {
                        direction: inherit;
                        box-sizing: border-box !important;
                        position: relative;
                        display: block;
                        //height: 100%;
                        width: auto;
                        visibility: visible;
                        max-width: 100%;
                        max-height: 100%;
                        scrollbar-width: none;
                        height: auto;
                        overflow: hidden auto;

                        & .simplebar-content {
                            & .simplebar-title {
                                box-shadow: 0 3px 3px $sekaiGray;
                                color: $lightWhite;
                                font-size: 1.5rem;
                                font-weight: 600;
                                @include flexRow;
                                justify-content: center;
                                align-items: center;
                                margin: 0 auto;
                                height: 4.375rem;
                                @include Nunito;

                                & .content-header {
                                    @include flexRow;
                                    @include absoluteCenter;
                                    width: 100%;
                                    height: 100%;
                                    background-color: rgba(255,255,255,.1) !important;
                                }

                            }
                        }
                    }
                }
            }

        }

        & .tacha {
            position: absolute;
            right: 20px;
            &:HOVER {
                opacity: 0.8;
                cursor: pointer;
            }
        }

        @include responsive_layout('media_992') {

        }
    }

</style>